import React, { useRef, useState, useEffect } from "react";
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import GpsFixedOutlinedIcon from '@mui/icons-material/GpsFixedOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import Cloud from '@mui/icons-material/Cloud';
import { createSvgIcon } from '@mui/material/utils';
import SvgIcon from '@mui/material/SvgIcon/SvgIcon';
import CreateIcon from '@mui/icons-material/Create';
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import Grid from '@mui/material/Grid';
import {SplitButtonMove} from './split-button-actionbar'
import ButtonGroup from '@mui/material/ButtonGroup';
import AddIcon from '@mui/icons-material/Add';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import GrainIcon from '@mui/icons-material/Grain';
import { observerAddToHandles } from "../../../handles/Handles";
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";
import Graphic from "@arcgis/core/Graphic.js";
import Point from "@arcgis/core/geometry/Point.js";
import SpatialReference from "@arcgis/core/geometry/SpatialReference.js";
import TextSymbol from "@arcgis/core/symbols/TextSymbol.js";
import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol.js";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol.js";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import Polyline from "@arcgis/core/geometry/Polyline.js";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import ClearSharpIcon from '@mui/icons-material/ClearSharp';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputAdornment from '@mui/material/InputAdornment';
import TodayIcon from '@mui/icons-material/Today';
import FilterNoneIcon from '@mui/icons-material/FilterNone';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import IconButton from '@mui/material/IconButton';
import Expand from "@arcgis/core/widgets/Expand.js";
import Search from "@arcgis/core/widgets/Search.js";
import AddLocationIcon from '@mui/icons-material/AddLocation';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Tooltip from '@mui/material/Tooltip';

const curPointer = {cursor: 'pointer'};

//var optionsEditToolSubMenu = ['Cancel','Delete', 'Move to Fabric Point','Move to XY'];
var selectedTool = '';
var searchCrGeo;
var startPath = [];
var endPath = [];
var editindex;
var editpoints = [];
var objectid;
var editfeaturegeo;
var el;
var fabric_oids = [];
var fabric_oids_points = [];
var crmasslist = [];
var batchgeo;
let fb_lyrid;
let cr_lyrid;

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const lightTheme = createTheme({
  palette: {
    mode: 'light',
  },
});

const CornerRecordEditWidget = ({ view,layerIds}) => {
  
  el = view.container
  const crEditDiv = useRef(null);

  const crfeaturelayer = new FeatureLayer({
    // URL to the service
    url: "https://www.ocgis.com/survey/rest/services/WebApps/Map_Layers_Associated_Documents/FeatureServer/55"
  });

  const cityfeaturelayer = new FeatureLayer({
    // URL to the service
    url: "https://ocgis.com/arcpub/rest/services/Map_Layers/City_Boundaries/MapServer/0"
  });

  let query = crfeaturelayer.createQuery();
    query.returnGeometry = true;
    query.outFields = ["*"];

    let queryCity = cityfeaturelayer.createQuery();
    queryCity.returnGeometry = true;
    queryCity.outFields = ["CITY"];
    queryCity.spatialRelationship = "intersects"; 
  
  const [appTheme, setAppTheme] = useState(darkTheme);
  const [optionsEditToolSubMenu, setOptionsEditToolSubMenu] = useState(['Cancel','Delete', 'Move to Fabric Point','Move to XY']);
  const [toolSelected, setToolSelected] = useState('');
  const [fromCRLabel, setFromCRLabel] = useState('From CR Number');
  const [toCRLabel, setToCRLabel] = useState('To CR Number');
  const [toolSelectedfor, setToolSelectedfor] = useState('');
  const [searchCr, setSearchCr] = useState('');
  const [showEditAttributesForm, setShowEditAttributesForm] = useState(false);
  const [showEditBatchForm, setShowEditBatchForm] = useState(false);
  const [disableEditMenu, setDisableEditMenu] = useState(false);
  const [disableBatchEdit, setDisableBatchEdit] = useState(true);
  const [dialogopenAddXY, setDialogOpenAddXY] = useState(false);
  const [dialogopenReplaceCR, setDialogOpenReplaceCR] = useState(false);
  const [dialogopen, setDialogOpen] = useState(false);
  const [dialogopenAddFB, setDialogOpenAddFB] = useState(false);
  const [dialogopenUpdateAttributes, setDialogopenUpdateAttributes] = useState(false);
  const [showRemoveFBTrash, setshowRemoveFBTrash] = useState(false);
  const [showFBFinalStep, setShowFBFinalStep] = useState(false);
  const [dialogDeleteCropen, setDialogDeleteCrOpen] = useState(false);
  const [dialogNotDeleteOpen, setDialogNotDeleteOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const searchCrRef = useRef();
  const [cornerRecordId, setCornerRecordId] = useState(layerIds["cornerRecords"]);
  const [fabricPointsId, setfabricPointsId] = useState(layerIds["fabricPoints"]);

  const [status, setStatus] = useState('');
  const [city, setCity] = useState('');
  const [year, setYear] = useState(2020);
  const [fromCR, setFromCR] = useState(0);
  const [toCR, setToCR] = useState(0);
  //const [crnum, setCrnum] = useState('');
  const [engco, setEngco] = useState('');
  const [engsvyname, setEngsvyname] = useState('');
  const [engsvynum, setEngsvynum] = useState('');
  // const [mslink, setMslink] = useState(null);
  const [fileddate, setFiledDate] = useState('');
  const [surveydate, setSurveyDate] = useState('');
  // const [unincorporated, setUnincorporated] = useState(null);

  
  let fabricpoint_layer = view.map.allLayers.filter((layer) => {
    return layer.layerId === fabricPointsId;
  }) as any;

  fb_lyrid = fabricpoint_layer.items[0].id

  let cr_layer = view.map.allLayers.filter((layer) => {
    return layer.layerId === cornerRecordId;
  }) as any;

  cr_lyrid =  cr_layer.items[0].id

  const longtoStringDate = (longdate) => {
    if (longdate != null){
          // var d = new Date(longdate);
    // var year = d.getUTCFullYear();
    // var month = d.getUTCMonth() + 1;
    // var date = d.getUTCDate();
    // d.setDate(d.getDate() + 20);

    var d = new Date(longdate);
  //  d.setDate(d.getDate() - 1);
   var year = d.getUTCFullYear();
   var month = ("0" + (d.getMonth() + 1)).slice(-2);
   var date = ("0" + d.getDate()).slice(-2);
   var fdate = year + "-" + month + "-" + date;

   // let MyDateString = ('0' + d.getDate()).slice(-2) + '/'
   //          + ('0' + (d.getMonth()+1)).slice(-2) + '/'
   //          + d.getFullYear();
   //year+"-"+month+"-"+date
   //d.getFullYear()+'-'+('0' + (d.getMonth()+1)).slice(-2) +'-'+('0' + d.getDate()).slice(-2) ;
     return fdate.trim();
    } else {
      return ''
    }

  }

  const handleChangeCrStatus = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  const getCityName = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    queryCity.geometry= batchgeo 
    cityfeaturelayer.queryFeatures(queryCity)
      .then(function(response){
        if(response.features.length > 0){
          setCity(response.features[0].attributes.CITY)
        }
    })
  };

  const handleClickDialogOpen = () => {
    setDialogOpen(true);
  };


  const handleClickDialogOpenAddXY = () => {
    setDialogOpenAddXY(true);
  };
  
  const handleClickDialogOpenReplaceCR = () => {
    setDialogOpenReplaceCR(true);
  };

  const handleClickDialogOpenAddFB = () => {
    setDialogOpenAddFB(true);
  };

  const clearCRform = () => {
    crmasslist = [];
    setFromCRLabel('From CR Number')
    setToCRLabel('To CR Number')
    setYear(2020)
    setFromCR(0);
    setToCR(0);
    setCity('');
   // setCrnum('');
    setStatus('')
    setEngco('')
    setEngsvyname('')
    setEngsvynum('')
    setFiledDate('')
  //  setMslink(null)
    setSurveyDate('')
  //  setUnincorporated(null)
  };

  const padToFour = (number) =>{
    if (number <= 9999) { number = ("000" + number).slice(-4); }
          return number;
  }

  const crRange = (cryear,crfrom,crto) => {
    crmasslist = [];
    for (let i = crfrom; i <= crto; i++) {
      var cr = 'CR ' + cryear + '-' + padToFour(i);
      crmasslist.push("'" + cr + "'")
    }
  }


  useEffect(() => {
    if (Number(year) && Number(toCR) && Number(fromCR)){
   //   setFromCRLabel('FROM: CR ' + year + '-' + padToFour(fromCR))
      setToCRLabel('TO: CR ' + year + '-' + padToFour(toCR))
      crRange(year,fromCR,toCR)
      setDisableBatchEdit(false)
    }
  }, [year,toCR,fromCR])

  useEffect(() => {
    if (Number(year) && Number(fromCR)){
      setFromCRLabel('FROM: CR ' + year + '-' + padToFour(fromCR))
    }
    if ((fromCR == 0)){
      crmasslist = [];
      setFromCRLabel('From CR Number')
      setDisableBatchEdit(true)
    }
  }, [year,fromCR])

  useEffect(() => {
    if (Number(year) && Number(toCR)){
      setToCRLabel('TO: CR ' + year + '-' + padToFour(toCR))
    }
    if ((toCR == 0)){
      crmasslist = [];
      setToCRLabel('To CR Number')
      setDisableBatchEdit(true)
    }
  }, [year,toCR])

  const handleDialogClose = () => {
    setDialogOpen(false);
    setDialogOpenAddXY(false);
    setDialogDeleteCrOpen(false);
    setDialogNotDeleteOpen(false)
    setDialogOpenAddFB(false)
    setDialogOpenReplaceCR(false);
    setDialogopenUpdateAttributes(false)
  };



  const hittest_opts = {
    include: fabricpoint_layer
  }

  const remove_hittest_opts = {
    include: fabricpoint_layer
  }


  const [opensub, setOpensub] = useState(false);
  const [showxypane, setShowxypane] = useState(false);
  const [showreplacepane, setShowReplacepane] = useState(false);
  const [showxypaneStep, setShowxypaneStep] = useState(false);
  const [showmovefabricypane, setShowmovefabricypane] = useState(false);
  const [showmovefabricDpane, setShowmovefabricDpane] = useState(false);
  const anchorRefsub = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [x_value, setXvalue] = useState(0);
  const [y_value, setYvalue] = useState(0);

  useEffect(() => {
    if (searchCrRef.current){

    let searchCrWidget = new Search({
      view: view,
      container:searchCrRef.current,
      popupEnabled:false 
      // sources: [{
      //   layer: new FeatureLayer({
      //     url: "https://www.ocgis.com/survey/rest/services/WebApps/Map_Layers_Associated_Documents/MapServer/55" + cr_id,
      //     outFields: ["*"]
      //   }),
      //   searchFields: ["crnum"],
      //   suggestionTemplate: "Corner Record: {crnum}",
      //   exactMatch: false,
      //   outFields: ["*"],
      //   name: "Corner Records",
      //   placeholder: "CR 0001",
      //   zoomScale: 20,
      // }]
    });

    searchCrWidget.on("select-result", function (event) {
      setSearchCr(event.result.feature.attributes.crnum)
      searchCrGeo = event.result.feature.geometry
    })
    return () => {
      searchCrWidget.destroy();
    };
    }
  }, [showreplacepane])




// view.map.findLayerById(cr_lyrid).refresh();

  const handleDialogOK = () => {
    setDialogOpen(false);

    editpoints[editindex] = [x_value,y_value];
    editfeaturegeo["points"] = editpoints;
    var updateFeature = new Graphic({
      geometry: editfeaturegeo,
      attributes: {
        "OBJECTID": objectid
      }
    });
    const edits = {
      updateFeatures: [updateFeature]
    };

    crfeaturelayer.applyEdits(edits).then(function (results) {
      view.goTo(editfeaturegeo);
      view.graphics.forEach(function (item) {
        if (item.attributes){
          if(item.attributes.id == 'Fabric Point' ){
                  view.graphics.remove(item);
                }
        }
      });
      view.map.findLayerById(cr_lyrid).refresh();
      clearCornerRecordEdit();
    })

  };

  const handleDialogOKAddXY = () => {
    setDialogOpenAddXY(false);
    editpoints.push([x_value,y_value])
    editfeaturegeo["points"] = editpoints;
    var updateFeature = new Graphic({
      geometry: editfeaturegeo,
      attributes: {
        "OBJECTID": objectid
      }
    });
    const edits = {
      updateFeatures: [updateFeature]
    };

    crfeaturelayer.applyEdits(edits).then(function (results) {
      view.goTo(editfeaturegeo);
      view.graphics.forEach(function (item) {
        if (item.attributes){
          if(item.attributes.id == 'Fabric Point' ){
                  view.graphics.remove(item);
                }
        }
      });
      view.map.findLayerById(cr_lyrid).refresh();
      clearCornerRecordEdit();
    })

  };

  const handleDialogOKCrReplace = () => {
    setDialogOpenReplaceCR(false);
    if (searchCrGeo){
      var updateFeature = new Graphic({
        geometry: searchCrGeo,
        attributes: {
          "OBJECTID": objectid
        }
      });
      const edits = {
        updateFeatures: [updateFeature]
      };
  
      crfeaturelayer.applyEdits(edits).then(function (results) {
        view.goTo(editfeaturegeo);
        view.map.findLayerById(cr_lyrid).refresh();
        clearCornerRecordEdit();
      })
    } else {
    }
   
  };


  const cancelEdit = () =>{
      setShowxypane(false) 
      setShowxypaneStep(false)
      setShowmovefabricypane(false)
      setShowmovefabricDpane(false)
      setDialogDeleteCrOpen(false);
      setDialogNotDeleteOpen(false)
      setShowFBFinalStep(false)
      clearCornerRecordEdit();
      setDisableEditMenu(false);
  }
  const handleDialogUpdateAttributes = () => {
    setDialogopenUpdateAttributes(false)
    let updateFeature = new Graphic({
      geometry: editfeaturegeo,
      attributes: {
        "OBJECTID": objectid,
        "engco": engco,
        "engsvyname": engsvyname,
        "engsvynum": engsvynum,
        "cityname": city,
        "surveydate": datetoEsridate(surveydate),
        "Status": status,
        "FiledDate": datetoEsridate(fileddate)
        // "mslink": mslink,
        // "Unincorporated": unincorporated
      }
    });
    const edits = {
      updateFeatures: [updateFeature]
    };
    crfeaturelayer.applyEdits(edits).then(function (results) {
      view.goTo(editfeaturegeo);
      view.map.findLayerById(cr_lyrid).refresh();
      clearCornerRecordEdit();
    })
  }

  const handleDialogUpdateBatchAttributes = () => {
    setDialogopenUpdateAttributes(false)
    var updatedfeatures = [];
    query.where = "crnum IN (" + crmasslist + ")";
    crfeaturelayer.queryFeatures(query)
      .then(function(results){
        results.features.forEach(function (item) {
            let croid = item.attributes.OBJECTID;
            let cr_geom = item.geometry;
            let updateFeature = new Graphic({
              geometry: cr_geom,
              attributes: {
                "OBJECTID": croid,
                "engco": engco,
                "engsvyname": engsvyname,
                "engsvynum": engsvynum,
                "cityname": city,
                "surveydate": datetoEsridate(surveydate),
                "Status": status,
                "FiledDate": datetoEsridate(fileddate),
                // "mslink": mslink,
                // "Unincorporated": unincorporated
              }
            });
            updatedfeatures.push(updateFeature);
          })
          if (updatedfeatures.length > 0) {
            const edits = {
              updateFeatures: updatedfeatures
            };
         crfeaturelayer.applyEdits(edits).then(function (results) {
            clearCornerRecordEdit();
          })
          } else {
          }
          

        })

  }

  const handleDialogAddFBOK = () => {
    setDialogOpenAddFB(false)
    if (fabric_oids.length > 0){
      if (fabric_oids_points.length > 0){
        fabric_oids_points.forEach(function (item) {
          editpoints.push(item)
        })
      }

      
      editfeaturegeo["points"] = editpoints;
      var updateFeature = new Graphic({
        geometry: editfeaturegeo,
        attributes: {
          "OBJECTID": objectid
        }
      });
      const edits = {
        updateFeatures: [updateFeature]
      };
  
      crfeaturelayer.applyEdits(edits).then(function (results) {
        view.goTo(editfeaturegeo);
        view.graphics.forEach(function (item) {
          if (item.attributes){
            if(item.attributes.id == 'Fabric Point' ){
                    view.graphics.remove(item);
                  }
          }
        });
        view.map.findLayerById(cr_lyrid).refresh();
        clearCornerRecordEdit();
      })
    }
  }
  const datetoEsridate = (str) =>{
    if (str) {
      let isValidDate = Date.parse(str);
      if (isValidDate) {
        var arr = str.split('-');
        var mm = arr[1];
        var dd = arr[2];
        var yyyy = arr[0];

        var mydate = mm + '/' + dd + '/' + yyyy +' 12:00';
        return mydate
      }
    } else {
      return null
    }
  }
  const handleDialogDeleteOK = () =>{
    if ((editpoints.length > 0)){
      editpoints.splice(editindex,1)
      editfeaturegeo["points"] = editpoints;
      var updateFeature = new Graphic({
        geometry: editfeaturegeo,
        attributes: {
          "OBJECTID": objectid
        }
      });

      const edits = {
        updateFeatures: [updateFeature]
      };

      crfeaturelayer.applyEdits(edits).then(function (results) {
        view.goTo(editfeaturegeo);
        view.map.findLayerById(cr_lyrid).refresh();
        clearCornerRecordEdit()
      })

    } else {
    }
    setDialogDeleteCrOpen(false)
  }
  
  view.on("click", (event)=> {
    if (selectedTool == 'addPointstoFabric') {
       el.style.cursor = "pointer"
      view.hitTest(event, hittest_opts).then((response) => {
        if (response.results.length) {
            const graphic = response.results[0].graphic;
            let attributes = graphic.attributes;
            let geometry = graphic.geometry
            attributes['id'] = 'Fabric Point'
            graphic.attributes = attributes
            if(fabric_oids.indexOf(attributes.OBJECTID) === -1) {
              fabric_oids.push(attributes.OBJECTID);
              fabric_oids_points.push([geometry.x,geometry.y])
              view.graphics.forEach(function (item) {
              if (item.attributes){
                if(item.attributes.OBJECTID == attributes.OBJECTID ){
                        view.graphics.remove(item);
                      }
              }
            });
              view.graphics.add(graphic)
              if (fabric_oids.length > 0){
                setshowRemoveFBTrash(true)
                setDisableEditMenu(true);
                setShowFBFinalStep(true);
              } else {
                setshowRemoveFBTrash(false)
                setDisableEditMenu(false);
                setShowFBFinalStep(false);
              }
          } else {
          }
          
            
            // setXvalue(graphic.geometry.x);
            // setYvalue(graphic.geometry.y); 
             
            // setShowmovefabricDpane(true)
          // do something with the graphic
        } else {
          setShowmovefabricDpane(false)
        }
      });    
      
    }
    if ((selectedTool == 'Move to XY')|| (selectedTool == 'ADD AT XY')){
      setXvalue(event.mapPoint.x);
      setYvalue(event.mapPoint.y);
      setShowxypane(true)
    } else {
      setShowxypane(false)
      setShowxypaneStep(false)
    }
  if ((selectedTool == 'Move to Fabric Point') && (showmovefabricypane)){
    view.hitTest(event, hittest_opts).then((response) => {
      if (response.results.length) {
          const graphic = response.results[0].graphic;
          let attributes = graphic.attributes;
          attributes['id'] = 'Fabric Point'
          graphic.attributes = attributes
          view.graphics.forEach(function (item) {
            if (item.attributes){
              if(item.attributes.id == 'Fabric Point' ){
                      view.graphics.remove(item);
                    }
            }
          });
          setXvalue(graphic.geometry.x);
          setYvalue(graphic.geometry.y); 
          view.graphics.add(graphic)
          setShowmovefabricDpane(true)
        // do something with the graphic
      } else {
        setShowmovefabricDpane(false)
      }
    });      
   }
  })

  

  useEffect(()=>{
    if (toolSelected !== ''){
      setShowPointGrid(false)
    } 
  },[toolSelected])

  

  useEffect(()=>{
  //  setSelectedTool(optionsEditToolSubMenu[selectedIndex])
    selectedTool = '';
    setToolSelected('');
    //setToolSelectedfor('');
    setSearchCr('');
    searchCrGeo = null;
  },[selectedIndex])

  const handleClicksub = () => {
    selectedTool = optionsEditToolSubMenu[selectedIndex]
    setToolSelected(selectedTool);
    console.info(`You clicked ${optionsEditToolSubMenu[selectedIndex]}`,selectedTool); 
    el.style.cursor = "default"
    if ((optionsEditToolSubMenu[selectedIndex] == 'Move to XY')||(optionsEditToolSubMenu[selectedIndex] == 'ADD AT XY')){
      setShowEditMultiTools(false)
      el.style.cursor = "crosshair"
   //   setShowxypane(true)
       setShowxypaneStep(true)
     
    } else {
      setShowxypane(false) 
      setShowxypaneStep(false)
    }

    if (optionsEditToolSubMenu[selectedIndex] == 'Move to Fabric Point'){
      //setShowxypane(true)
     // fabricpoint_layer.visible = true;
    setShowEditMultiTools(false)
      setShowmovefabricypane(true)
      view.map.findLayerById(fb_lyrid).visible = true;
      el.style.cursor = "pointer"
    } else {
      setShowmovefabricypane(false)
      setShowmovefabricDpane(false)
     // setShowxypane(false) 
    }

    if (optionsEditToolSubMenu[selectedIndex] == 'Delete'){
      el.style.cursor = "default"
      if ((editpoints.length > 1) && (editindex)){
        setDialogDeleteCrOpen(true);
      } else {
        setDialogNotDeleteOpen(true)
      }
    } 

    if (optionsEditToolSubMenu[selectedIndex] == 'Cancel'){
      setShowxypane(false) 
      setShowxypaneStep(false)
      setShowmovefabricypane(false)
      setShowmovefabricDpane(false)
      setDialogDeleteCrOpen(false);
      setDialogNotDeleteOpen(false)
      setShowFBFinalStep(false)
      clearCornerRecordEdit();
    }
    
    if (optionsEditToolSubMenu[selectedIndex] == 'ADD on Fabric Point'){
      setShowEditMultiTools(false)
      addPointstoFabric();
    }
    //
  };

  useEffect(()=>{
      endPath = []
      creditgraphicslayer.graphics.forEach(function (item) {
        if (item.attributes){
          if(item.attributes.id == 'moveTo' || item.attributes.id == 'movePath'){
                  creditgraphicslayer.remove(item);
                }
        }
        
      })
      let pointAtt = {
        x: Number(x_value),
        y: Number(y_value),
        id: 'moveTo'
      };

      let lineAtt = {
        id: 'movePath'
      };
  
   
      let movetoPoint = new Point({
        x:  Number(x_value),
        y:  Number(y_value),
        spatialReference: inSR
      })
      let movepointGraphic = new Graphic({
        geometry: movetoPoint,
        symbol: moveCRsymbol,
        attributes: pointAtt
      });

      endPath = [Number(x_value), Number(y_value)]

      let thepath =  [startPath, endPath]
      let line = new Polyline({
        hasZ: false,
        hasM: true,
        paths: thepath,
        spatialReference: inSR
      });

      let moveppathGraphic = new Graphic({
        geometry: line,
        symbol: pathSymbolWhiteDash,
        attributes: lineAtt
      });

      creditgraphicslayer.graphics.addMany([movepointGraphic]);
    //  creditgraphicslayer.graphics.addMany([moveppathGraphic]);
    },[x_value, y_value])
  
  



  const handleMenuItemClicksub = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
    setOpensub(false);
    setShowxypane(false)
    setShowxypaneStep(false)
    setShowmovefabricypane(false)
    setShowmovefabricDpane(false)
    console.info(`You chose ${optionsEditToolSubMenu[index]}`);
    if (optionsEditToolSubMenu[index] == 'Delete'){
      el.style.cursor = "default"
      if ((editpoints.length > 1) && (editindex)){
        setDialogDeleteCrOpen(true);
      } else {
        setDialogNotDeleteOpen(true)
      }
      
    } 

    if (optionsEditToolSubMenu[index] == 'Cancel'){
      setShowxypane(false) 
      setShowxypaneStep(false)
      setShowmovefabricypane(false)
      setShowmovefabricDpane(false)
      setDialogDeleteCrOpen(false);
      setDialogNotDeleteOpen(false)
      setShowFBFinalStep(false)
      clearCornerRecordEdit();
    }
  };

  const handleTogglesub = () => {
    setOpensub((prevOpen) => !prevOpen);

  };

  const handleClosesub = (event: Event) => {
    if (
      anchorRefsub.current &&
      anchorRefsub.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpensub(false);
  };

   let selectCRsymbol = new SimpleMarkerSymbol ({
      style: "circle",
      color: "red",
      size: "16pt",
      outline: {  // autocasts as new SimpleLineSymbol()
        color: "red",
        width: 1.5
      }
    })

    let moveCRsymbol = new SimpleMarkerSymbol ({
      style: "x",
      color: "red",
      size: "14pt",
      outline: {  // autocasts as new SimpleLineSymbol()
        color: "yellow",
        width: 2
      }
    })

    let pathSymbolWhiteDash = new SimpleLineSymbol  ({
      style: "dash",
      color: "white",
      width: "1.5px"
    })

  let creditgraphicslayer; 
  let selectedGraphicHalo

  let layr = view.map.allLayers.filter((layer) => {
    return layer.id === "cornerRecord_edit_graphiclyr";
  }) as any;
  
  if (layr.length == 0){
    creditgraphicslayer  = new GraphicsLayer({
      id: "cornerRecord_edit_graphiclyr",
      title: "Corner Records Edit Graphics",
      listMode: "hide",
    });
    view.map.add(creditgraphicslayer, view.map.allLayers.length);
  } else if (layr.length == 1){
    creditgraphicslayer =  layr.getItemAt(0)
  
  } else {
  }
    let inSR = new SpatialReference({ wkid: 2230 });
    const [gridItems, setGridItems] = useState([]);
    const [dataready, setDataReady] = useState("");
    const [showEditMultiTools, setShowEditMultiTools] = useState(false);
    const [showAddPointsOnFabric, setShowAddPointsOnFabric] = useState(false);
    const [showPointGrid, setShowPointGrid] = useState(false);
    //setShowEditMultiTools(false)
    // this function adds a new grid item
    // const ongridClick = () => {
    //  setGridItems([...gridItems, {text: "new row", id: gridItems.length + 1}]);
    // };



  const [currentValue, setCurrentValue] = useState<any>();
  const [showEditMenu, setShowEditMenu] = useState(false)
  // let layr = view.map.allLayers.filter((layer) => {
  //     return layer.id === "cornerRecord_edit_graphiclyr";
  //   }) as any;
  //   if (layr.length) {
  //     // layr.getItemAt(0).graphics.removeAll();
  //     // view.map.remove(layr.getItemAt(0));
      
  //   } else{
  //     creditgraphicslayer = new GraphicsLayer({
  //     id: "cornerRecord_edit_graphiclyr",
  //     title: "Corner Records Edit Graphics",
  //     listMode: "hide",
  //   });
  //   view.map.add(creditgraphicslayer, view.map.allLayers.length);
  //   } 
      
   


  //Can add export
const clearCornerRecordEdit = () => {
          el.style.cursor = "default"
          setShowEditAttributesForm(false)
          setShowEditBatchForm(false)
          setshowRemoveFBTrash(false)
          setShowFBFinalStep(false)
          setGridItems([])
          setShowEditMultiTools(false)
          setShowReplacepane(false);
          setShowAddPointsOnFabric(false)
          setShowPointGrid(false)
          setShowxypane(false)
          setShowxypaneStep(false)
          setShowmovefabricypane(false)
          setShowmovefabricDpane(false)
          setFromCRLabel('From CR Number')
          setToCRLabel('To CR Number')
          setYear(2020)
          clearCRform();
          editindex = null;
          objectid = null;
          editfeaturegeo = null;
          editpoints = [];
          fabric_oids = [];
          fabric_oids_points = [];
          selectedTool = ''
          setToolSelected('');
          setToolSelectedfor('');
          setSearchCr('');
          searchCrGeo = null;
          let layr = view.map.allLayers.filter((layer) => {
            return layer.id === "cornerRecord_edit_graphiclyr";
          }) as any;
          if(layr.length){
            layr.getItemAt(0).graphics.removeAll();
          creditgraphicslayer.graphics.forEach(function (item) {
            if (item.attributes){
              if(item.attributes.id == 'moveTo' || item.attributes.id == 'movePath' || item.attributes.id == 'selectedHalo'){
                      creditgraphicslayer.remove(item);
                    }
            }
            
          })
          creditgraphicslayer.graphics.forEach(function (item) {
            if (item.attributes){
              if(item.attributes.id == 'moveTo' || item.attributes.id == 'movePath' || item.attributes.id == 'selectedHalo'){
                      creditgraphicslayer.remove(item);
                    }
            }
            
          })
          view.map.remove(layr, view.map.allLayers.length);
          creditgraphicslayer.graphics.removeAll();
          setDisableEditMenu(false);
        }
          view.graphics.forEach(function (item) {
            if (item.attributes){
              if(item.attributes.id == 'Fabric Point' ){
                      view.graphics.remove(item);
                    }
            }
          });
          
          view.graphics.forEach(function (item) {
            if (item.attributes){
              if(item.attributes.id == 'Fabric Point'){
                      view.graphics.remove(item);
                    }
            }
          });

          view.graphics.forEach(function (item) {
            if (item.attributes){
              if(item.attributes.id == 'Fabric Point'){
                      view.graphics.remove(item);
                    }
            }
          });
          view.popup.autoOpenEnabled = true;
};

  const onClickEditPen = () => {
    if (showEditMenu){
        setShowEditMenu(false)
    } else {
        setShowEditMenu(true)
    }
    
}


  useEffect(()=>{
    observerAddToHandles(
      reactiveUtils.watch(
        () => view.popup.selectedFeature,
        (e) => {
          clearCornerRecordEdit()
        }
      ),
      "clearCornerRecordGrid"
    );
  },[])




 
  const selectedFeature = view.popup.selectedFeature;
  const EditMenu = () => (
    <div id="edit-menu">
      <p>Edit Menu</p>
    </div>
  )

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const EditPencilIcon = createSvgIcon(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="h-6 w-6"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>,
    'Plus',
  );

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const removeFBselection = (e) => {
    if (fabric_oids.length > 0){
      let oid = fabric_oids.pop();
      fabric_oids_points.pop();
      if (fabric_oids.length == 0){
        setshowRemoveFBTrash(false)
        setDisableEditMenu(false);
        setShowFBFinalStep(false)
      }
      view.graphics.forEach(function (item) {
        if (item.attributes){
          if(item.attributes.OBJECTID == oid ){
                  view.graphics.remove(item);
                }
        }
      });
    }
  };


  const handleUpdateAttributesClicked = (e) => {
    setDialogopenUpdateAttributes(true)
  }
  
  const handleIndexPointClick = (e) => {
    setToolSelectedfor(e.currentTarget.innerText)
    if (e.currentTarget.innerText == 'ADD'){
    //  setToolSelected('ADD')
      setOptionsEditToolSubMenu(['ADD on Fabric Point','ADD AT XY']);
      setShowEditMultiTools(true)
      setShowReplacepane(false);
      editindex = null;
      creditgraphicslayer.graphics.forEach(function (item) {
        if (item.attributes){
          if(item.attributes.id == 'moveTo' || item.attributes.id == 'movePath' || item.attributes.id == 'selectedHalo'){
                  creditgraphicslayer.remove(item);
                }
        }
        
      })
      creditgraphicslayer.graphics.forEach(function (item) {
        if (item.attributes){
          if(item.attributes.id == 'moveTo' || item.attributes.id == 'movePath' || item.attributes.id == 'selectedHalo'){
                  creditgraphicslayer.remove(item);
                }
        }
        
      })

    } else if (( Number(e.currentTarget.innerText))||(e.currentTarget.innerText == 0)){
 //     setToolSelected(e.currentTarget.innerText)
      setToolSelectedfor("POINT: "+ e.currentTarget.innerText)
      setOptionsEditToolSubMenu(['Delete', 'Move to Fabric Point','Move to XY']);
      startPath = [];
      endPath = []
      creditgraphicslayer.graphics.forEach(function (item) {
        if (item.attributes){
          if(item.attributes.id == 'selectedHalo'){
                  creditgraphicslayer.remove(item);
                }
        }
        
      })
      let pointAtt = {
        x: Number(e.currentTarget.value.split(',')[0]),
        y: Number(e.currentTarget.value.split(',')[1]),
        index: Number(e.currentTarget.innerText),
        id: 'selectedHalo'
      };
      editindex = Number(e.currentTarget.innerText);
      setXvalue(Number(e.currentTarget.value.split(',')[0]))
      setYvalue(Number(e.currentTarget.value.split(',')[1]))
      const {value} = e.currentTarget.value;
      var editPoint = new Point({
        x: Number(e.currentTarget.value.split(',')[0]),
        y: Number(e.currentTarget.value.split(',')[1]),
        spatialReference: inSR
      })
      var pointGraphic = new Graphic({
        geometry: editPoint,
        symbol: selectCRsymbol,
        attributes: pointAtt
      });
      creditgraphicslayer.graphics.add(pointGraphic);
      startPath = [Number(e.currentTarget.value.split(',')[0]), Number(e.currentTarget.value.split(',')[1])]
      setShowEditMultiTools(true)
      setShowReplacepane(false);

    } else  if (e.currentTarget.innerText == 'REPLACE'){
      editindex = null;
      setShowEditMultiTools(false);
      setShowPointGrid(false);
      setShowReplacepane(true);
      creditgraphicslayer.graphics.forEach(function (item) {
        if (item.attributes){
          if(item.attributes.id == 'moveTo' || item.attributes.id == 'movePath' ||item.attributes.id == 'selectedHalo'){
                  creditgraphicslayer.remove(item);
                }
        }
      })
      creditgraphicslayer.graphics.forEach(function (item) {
        if (item.attributes){
          if(item.attributes.id == 'moveTo' || item.attributes.id == 'movePath' || item.attributes.id == 'selectedHalo'){
                  creditgraphicslayer.remove(item);
                }
        }
        
      })
    } 

  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
    // setShowEditMultiTools(false)
    // setShowPointGrid(false)
    clearCornerRecordEdit();
    view.graphics.forEach(function (item) {
      if (item.attributes){
        if(item.attributes.id == 'Fabric Point' ){
                view.graphics.remove(item);
              }
      }
    });
    view.popup.autoOpenEnabled = true;

  };

  

  const addPointstoFabric = () => {

    setOpen(false);
    creditgraphicslayer.graphics.removeAll();
    view.popup.autoOpenEnabled = false;
    setDisableEditMenu(true);
   // clearCornerRecordEdit()
   setShowFBFinalStep(false)
    selectedTool = 'addPointstoFabric'
   // setToolSelected('addPointstoFabric')
    if (selectedFeature.attributes.crnum){
        query.where = "crnum ='" + selectedFeature.attributes.crnum + "'";
        crfeaturelayer.queryFeatures(query)
    .then(function(response){
      //view.map.findLayerById("18a2310c527-layer-63").visible = true;
      view.map.findLayerById(fb_lyrid).visible = true;
      el.style.cursor = "pointer"
        if(response.features[0].geometry["points"]){
            setDataReady('Ready')
            editfeaturegeo = response.features[0].geometry
            let crpointslist = response.features[0].geometry["points"];
            objectid = response.features[0].attributes.OBJECTID;
            editpoints = crpointslist;
            // setGridItems(crpointslist)
             setShowPointGrid(false)
            setShowEditMultiTools(false)
            setShowReplacepane(false);
            crpointslist.forEach(function (point, index) {
              var nadPoint = new Point({
                x: point[0],
                y: point[1],
                spatialReference: inSR
              })

              let textSymbol = new TextSymbol({
                color: "red",
                  haloColor: "yellow",
                  haloSize: "1px",
                  text: index,
                  xoffset: 10,
                  yoffset: 10,
                  font: {  // autocast as new Font()
                    size: 20,
                    family: "sans-serif",
                    weight: "bold"
                  }
              });

              var pointGraphic = new Graphic({
                geometry: nadPoint,
                symbol: textSymbol
              });
              creditgraphicslayer.graphics.add(pointGraphic);
            })
            el.style.cursor = "pointer"
            setShowAddPointsOnFabric(true)
        }
    });
    }
  };

  const editBatch = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
        
      return;
    }

    setOpen(false);
    setShowAddPointsOnFabric(false)
    creditgraphicslayer.graphics.removeAll();
    view.popup.autoOpenEnabled = false;
    setDisableEditMenu(true);
    if (selectedFeature.attributes.crnum){
      query.where = "crnum ='" + selectedFeature.attributes.crnum + "'";
      crfeaturelayer.queryFeatures(query)
  .then(function(response){
      if(response.features[0].geometry["points"]){
          batchgeo = response.features[0].geometry;
          setDataReady('Ready')
          // editfeaturegeo = response.features[0].geometry
          // let crpointslist = response.features[0].geometry["points"];
          // console.log('handleDialogOK crpointslist',crpointslist)
          // objectid = response.features[0].attributes.OBJECTID;
          // editpoints = crpointslist;
          // setGridItems(crpointslist)
          setShowPointGrid(false)
          setShowEditMultiTools(false)
          setShowReplacepane(false);

          setStatus(response.features[0].attributes.Status)
          if (response.features[0].attributes.cityname){
            setCity(response.features[0].attributes.cityname)
          }else {
            setCity('')
          }
          
    //      setCrnum(response.features[0].attributes.crnum)
          if (response.features[0].attributes.crnum){
            if (response.features[0].attributes.crnum.split(' ')){
              if (response.features[0].attributes.crnum.split(' ')[1].split('-')){
                setYear(Number(response.features[0].attributes.crnum.split(' ')[1].split('-')[0]))
                setFromCR(Number(response.features[0].attributes.crnum.split(' ')[1].split('-')[1]))
              }
            }
          }
          setEngco(response.features[0].attributes.engco)
          setEngsvyname(response.features[0].attributes.engsvyname)
          setEngsvynum(response.features[0].attributes.engsvynum)
       //   setMslink(response.features[0].attributes.mslink)
          setFiledDate(longtoStringDate(response.features[0].attributes.FiledDate))
          setSurveyDate(longtoStringDate(response.features[0].attributes.surveydate))
    //      setUnincorporated(response.features[0].attributes.Unincorporated)
          // crpointslist.forEach(function (point, index) {
          //   var nadPoint = new Point({
          //     x: point[0],
          //     y: point[1],
          //     spatialReference: inSR
          //   })

          //   let textSymbol = new TextSymbol({
          //     color: "red",
          //       haloColor: "yellow",
          //       haloSize: "1px",
          //       text: index,
          //       xoffset: 10,
          //       yoffset: 10,
          //       font: {  // autocast as new Font()
          //         size: 20,
          //         family: "sans-serif",
          //         weight: "bold"
          //       }
          //   });

          //   var pointGraphic = new Graphic({
          //     geometry: nadPoint,
          //     symbol: textSymbol
          //   });
           
          //   creditgraphicslayer.graphics.add(pointGraphic);
          // })
          
        //  setGridItems([...gridItems, {text:""+index+"", id: gridItems.length + 1}]);
      }
    // returns a feature set with features containing the
    // POPULATION attribute and each feature's geometry
    setShowEditAttributesForm(true)
    setShowEditBatchForm(true)
  });
  }
    // setShowEditAttributesForm(true)
    // setShowEditBatchForm(true)
  };

  const editAttributes = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
        
      return;
    }

    setOpen(false);
    setShowAddPointsOnFabric(false)
    creditgraphicslayer.graphics.removeAll();
    view.popup.autoOpenEnabled = false;
    setDisableEditMenu(true);
    if (selectedFeature.attributes.crnum){
        query.where = "crnum ='" + selectedFeature.attributes.crnum + "'";
        crfeaturelayer.queryFeatures(query)
    .then(function(response){
        if(response.features[0].geometry["points"]){
            setDataReady('Ready')
            editfeaturegeo = response.features[0].geometry
            batchgeo = response.features[0].geometry
            let crpointslist = response.features[0].geometry["points"];
            objectid = response.features[0].attributes.OBJECTID;
            editpoints = crpointslist;
            setGridItems(crpointslist)
            setShowPointGrid(false)
            setShowEditMultiTools(false)
            setShowReplacepane(false);
            setStatus(response.features[0].attributes.Status)
            if (response.features[0].attributes.cityname){
              setCity(response.features[0].attributes.cityname)
            }else {
              setCity('')
            }
      //      setCrnum(response.features[0].attributes.crnum)
            setEngco(response.features[0].attributes.engco)
            setEngsvyname(response.features[0].attributes.engsvyname)
            setEngsvynum(response.features[0].attributes.engsvynum)
       //     setMslink(response.features[0].attributes.mslink)
            setFiledDate(longtoStringDate(response.features[0].attributes.FiledDate))
            setSurveyDate(longtoStringDate(response.features[0].attributes.surveydate))
      //      setUnincorporated(response.features[0].attributes.Unincorporated)
            crpointslist.forEach(function (point, index) {
              var nadPoint = new Point({
                x: point[0],
                y: point[1],
                spatialReference: inSR
              })

              let textSymbol = new TextSymbol({
                color: "red",
                  haloColor: "yellow",
                  haloSize: "1px",
                  text: index,
                  xoffset: 10,
                  yoffset: 10,
                  font: {  // autocast as new Font()
                    size: 20,
                    family: "sans-serif",
                    weight: "bold"
                  }
              });

              var pointGraphic = new Graphic({
                geometry: nadPoint,
                symbol: textSymbol
              });
             
              creditgraphicslayer.graphics.add(pointGraphic);
            })
            
          //  setGridItems([...gridItems, {text:""+index+"", id: gridItems.length + 1}]);
        }
      // returns a feature set with features containing the
      // POPULATION attribute and each feature's geometry
      setShowEditAttributesForm(true)
    });
    }
  };

  const editMultipoint = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
        
      return;
    }

    setOpen(false);
    setShowAddPointsOnFabric(false)
    creditgraphicslayer.graphics.removeAll();
    view.popup.autoOpenEnabled = false;
    setDisableEditMenu(true);
    if (selectedFeature.attributes.crnum){
        query.where = "crnum ='" + selectedFeature.attributes.crnum + "'";
        crfeaturelayer.queryFeatures(query)
    .then(function(response){
        
        if(response.features[0].geometry["points"]){
            setDataReady('Ready')
            editfeaturegeo = response.features[0].geometry
            let crpointslist = response.features[0].geometry["points"];
            objectid = response.features[0].attributes.OBJECTID;
            editpoints = crpointslist;
            setGridItems(crpointslist)
            setShowPointGrid(true)
            setShowEditMultiTools(false)
            setShowReplacepane(false);
            crpointslist.forEach(function (point, index) {
              var nadPoint = new Point({
                x: point[0],
                y: point[1],
                spatialReference: inSR
              })

              let textSymbol = new TextSymbol({
                color: "red",
                  haloColor: "yellow",
                  haloSize: "1px",
                  text: index,
                  xoffset: 10,
                  yoffset: 10,
                  font: {  // autocast as new Font()
                    size: 20,
                    family: "sans-serif",
                    weight: "bold"
                  }
              });

              var pointGraphic = new Graphic({
                geometry: nadPoint,
                symbol: textSymbol
              });
             
              creditgraphicslayer.graphics.add(pointGraphic);
            })
            
          //  setGridItems([...gridItems, {text:""+index+"", id: gridItems.length + 1}]);
        }
      // returns a feature set with features containing the
      // POPULATION attribute and each feature's geometry
    });
    }
  };

 

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus();
    }
    prevOpen.current = open;
  }, [open]);


  return (
    
    
    <div ref={crEditDiv}>
    {/* <ThemeProvider theme={appTheme}> */}
      {selectedFeature?.layer?.layerId === cornerRecordId?
        <>
        
         <Stack direction="row" spacing={2}>

      <div>
        <button style={{ marginLeft: "6px" }} 
        disabled={disableEditMenu}
        className="nextButton" 
        ref={anchorRef}
        id="composition-button"
        aria-controls={open ? 'composition-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}>
        <svg xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" height="12px" width="12px" fill="white" viewBox="0 0 512 512">
        <path fillRule="nonzero" d="M400.08 26.04c-1.82-1.81-3.72-3.14-5.7-3.97-1.89-.8-4.05-1.2-6.47-1.2-2.38 0-4.52.41-6.4 1.21-1.95.83-3.83 2.15-5.63 3.96l-36.73 36.73 104.11 104.57 37.22-37.22c1.55-1.54 2.69-3.29 3.44-5.18l.15-.38c.71-1.96 1.06-4.17 1.06-6.56 0-2.49-.4-4.82-1.22-6.89l-.22-.62c-.74-1.64-1.79-3.16-3.16-4.52l-80.45-79.93zM69.03 332.8l105.03 103.23 215.22-215.22-104.09-104.17L69.03 332.8zm86.27 113.97-96.28-94.62-27.86 99.15c-4.45 15.91-7.46 28.06-9.05 36.44 19.79-5.98 40.2-11.61 59.73-18.29 10.75-3.39 21.78-6.87 39.25-12.28l24.1-7.34 10.11-3.06zM402.45 2.91c4.5 1.89 8.61 4.69 12.3 8.37l80.45 79.93c3.35 3.33 5.9 7.12 7.68 11.27l.43.96c1.81 4.57 2.69 9.48 2.69 14.56 0 4.87-.8 9.56-2.45 13.97l-.23.63c-1.79 4.53-4.47 8.67-8.08 12.28l-44.64 44.6c-4.07 4.05-10.66 4.03-14.71-.04L317.04 70.11c-4.07-4.07-4.07-10.68 0-14.76l44.08-44.07c3.65-3.66 7.72-6.45 12.23-8.36C377.92.98 382.77 0 387.91 0c5.1 0 9.94.97 14.54 2.91zM174.77 462.66l-23.54 7.07-24.03 7.32c-30.42 9.57-60.67 18.96-91.16 28.28-10.56 3.19-17.58 5.27-20.89 6.17-1.41.4-2.83.54-4.3.39-6.12-.62-9.68-4.3-10.63-11.06-.33-2.28-.28-5.21.13-8.77 1.03-9 4.62-24.47 10.75-46.39l32.27-114.82c.5-1.78 1.43-3.33 2.66-4.55L277.79 94.52c4.07-4.07 10.68-4.07 14.76 0l118.84 118.97c4.05 4.07 4.03 10.65-.02 14.7l-231.66 231.7a10.373 10.373 0 0 1-4.94 2.77z"/></svg>
    </button> { showEditMenu ? <EditMenu /> : null }
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper sx={{ width: 300, maxWidth: '90%' }}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    {/* <MenuItem onClick={handleClose}>
                      <ListItemIcon><GpsFixedOutlinedIcon fontSize="small" /></ListItemIcon>
                      <ListItemText>Add a Point on XY</ListItemText>
                    </MenuItem> */}
                    {/* <MenuItem onClick={addPointstoFabric}> 
                      <ListItemIcon><AddToPhotosIcon fontSize="small" /></ListItemIcon>
                      <ListItemText>Add Points on Fabric Points</ListItemText>
                    </MenuItem> */}
                    <MenuItem onClick={editMultipoint}> 
                      <ListItemIcon className = "cr_edit_icons"><GrainIcon fontSize="small" /></ListItemIcon>
                      <ListItemText> Edit Multipoints</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={editAttributes}>
                      <ListItemIcon className = "cr_edit_icons"><DnsOutlinedIcon fontSize="small" /></ListItemIcon>
                      <ListItemText> Edit Attributes</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={editBatch}>
                      <ListItemIcon className = "cr_edit_icons"> <FilterNoneIcon fontSize="small" /></ListItemIcon>
                      <ListItemText> Batch Edit</ListItemText>
                    </MenuItem>
                    {/* <MenuItem onClick={handleClose}>
                      <ListItemIcon><FindReplaceIcon fontSize="small" /></ListItemIcon>
                      <ListItemText>Replace Geometry</ListItemText>
                    </MenuItem> */}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack> 
    <Paper>
    {disableEditMenu == true?<><Typography fontSize="medium" sx={{ fontWeight: 'bold', textAlign: 'right'}}>{toolSelectedfor}
    <Tooltip title="Close">
    <IconButton color="error" size="small" onClick = {cancelEdit}>
      <CloseOutlinedIcon/>
    </IconButton>
    </Tooltip>
    </Typography>
    {/* <Typography class = "cr_edit_ToolTitle" variant="h6">{toolSelectedfor}</Typography> */}
    </>:""}
    {/* <button onClick={ongridClick}>Add Row</button> */}
   
    {showAddPointsOnFabric == true?<>
      <Typography fontSize="medium" sx={{ fontWeight: 'bold' }}>Add Points on Fabric Points</Typography>
      <Typography   sx={{textDecoration: 'underline'}} fontSize="small">Step 1: Select Points{showRemoveFBTrash == true?<><Button title = "Remove Selection" size = "medium" onClick={removeFBselection} endIcon={<RestoreFromTrashIcon />}></Button></>:""}</Typography>
      {showFBFinalStep == true?<><Typography   sx={{textDecoration: 'underline'}}  fontSize="small">Step 2:<ButtonGroup
          disableElevation
          variant="text"
          aria-label="Disabled elevation buttons"
          size = "small"
          fullWidth={true}
        >
          <Button onClick={handleClose} endIcon={<CancelIcon />}>Cancel</Button>
          <Button  onClick={handleClickDialogOpenAddFB} endIcon={<SaveIcon />}>Save</Button>
        </ButtonGroup>
      </Typography></>:""}

    </>:""}
    {showmovefabricypane == true?<>
      <Typography fontSize="medium" sx={{ fontWeight: 'bold' }}>{toolSelected}</Typography> 
     <Typography  sx={{textDecoration: 'underline'}}  fontSize="small">Step 3: Choose a Fabric Point on the map.</Typography>
     {showmovefabricDpane == true?<> 
    <Typography  sx={{textDecoration: 'underline'}}  fontSize="small">Step 4: <ButtonGroup
  disableElevation
  variant="text"
  aria-label="Disabled elevation buttons"
  size = "small"
  fullWidth={true}
>
  <Button onClick={handleClose}>Cancel</Button>
  <Button  onClick={handleClickDialogOpen} endIcon={<PlayCircleOutlineIcon />}>Move</Button>

</ButtonGroup></Typography>
   </> :""}
    </> :""}
    {showxypaneStep == true?<><Typography fontSize="medium" sx={{ fontWeight: 'bold' }}>{toolSelected}</Typography><Typography  sx={{textDecoration: 'underline'}} fontSize="small">Step 3: Click Map</Typography></>:""}
      {showxypane == true?<> 
      <Box
            component="form"
            sx={{
              '& > :not(style)': { m: 1, width: 19/20 },
            }}
            noValidate
            autoComplete="off"
    > 
      X<TextField id="textfield-x" value = {x_value} variant="standard" size="small" type="number"/><br></br>
      Y<TextField id="textfield-y" value = {y_value} variant="standard" size="small" type="number"/>
      
    </Box>
    <Typography  sx={{textDecoration: 'underline'}}  fontSize="small">Step 4: <ButtonGroup
  disableElevation
  variant="text"
  aria-label="Disabled elevation buttons"
  size = "small"
  fullWidth={true}
>
  <Button onClick={handleClose}>Cancel</Button>
  {toolSelected == 'Move to XY'?<> <Button  onClick={handleClickDialogOpen} >Move</Button></> :""}
  {toolSelected == 'ADD AT XY'?<> <Button  onClick={handleClickDialogOpenAddXY} >Add</Button></> :""}
</ButtonGroup></Typography>
    </> :""}
    {showPointGrid == true?<>
         <Typography fontSize="medium" sx={{ fontWeight: 'bold' }}>Edit Multipoint</Typography>
         <Typography   sx={{textDecoration: 'underline'}} fontSize="small" >Step 1: Select</Typography>
         <Grid container className='v-timeline-container'>
          {
            gridItems.map((item,key) => {
                return (
                <Button key={key} value ={item} size="small" onClick = {handleIndexPointClick}>{key}</Button>
                )
            })
          }
         </Grid>
         <Button  size="small" onClick = {handleIndexPointClick}>ADD</Button>
         <Button  size="small" onClick = {handleIndexPointClick}>REPLACE</Button>
         </>: ""}
         {showreplacepane == true?<> 
         {/* <Typography variant="h5">Replace Geometry</Typography> */}
         <Typography   sx={{textDecoration: 'underline'}}  fontSize="small">Step 2: Enter replacing Corner Record #</Typography>
         <div className = "searchCrDiv" id = "searchCrDiv" ref={searchCrRef}></div>
         {searchCr !== ''?<><Typography  sx={{textDecoration: 'underline'}}  fontSize="small">Step 3:<Button  size="small" onClick = {handleClickDialogOpenReplaceCR}>Replace with {searchCr}</Button></Typography></>:""}
         {/* <TextField id="replace-cr" variant="standard" size="small" type="text"/>  */}
         {/* <Button onClick={handleClose}><ListItemIcon><FindReplaceIcon fontSize="small" /></ListItemIcon></Button> */}
         </>:""}
         {showEditMultiTools == true?<> 
          <Typography   sx={{textDecoration: 'underline'}} fontSize="small">Step 2: Select a tool</Typography>
         {/* <SplitButtonMove view={view}></SplitButtonMove> */}
         <React.Fragment>
      <ButtonGroup variant="text" ref={anchorRefsub} aria-label="split button" fullWidth={true}>
        <Button onClick={handleClicksub}>{optionsEditToolSubMenu[selectedIndex]}</Button>
        <Button
          size="small"
          aria-controls={opensub ? 'split-button-menu' : undefined}
          aria-expanded={opensub ? 'true' : undefined}
          aria-label="select tool"
          aria-haspopup="menu"
          onClick={handleTogglesub}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={opensub}
        anchorEl={anchorRefsub.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClosesub}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {optionsEditToolSubMenu.map((option, index) => (
                    <MenuItem
                      key={option}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClicksub(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

 
    </React.Fragment>
         </> :""}
         
         {/* <ButtonGroup variant="text" size="small" aria-label="text button group">
        <Button>One</Button>
        <Button>Two</Button>
        <Button>Three</Button>
      </ButtonGroup> */}
         
        {/* <button style={{ marginLeft: "6px" }} className="nextButton" onClick={onClickEditPen}>
        <svg xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" height="12px" width="12px" fill="white" viewBox="0 0 512 512">
        <path fillRule="nonzero" d="M400.08 26.04c-1.82-1.81-3.72-3.14-5.7-3.97-1.89-.8-4.05-1.2-6.47-1.2-2.38 0-4.52.41-6.4 1.21-1.95.83-3.83 2.15-5.63 3.96l-36.73 36.73 104.11 104.57 37.22-37.22c1.55-1.54 2.69-3.29 3.44-5.18l.15-.38c.71-1.96 1.06-4.17 1.06-6.56 0-2.49-.4-4.82-1.22-6.89l-.22-.62c-.74-1.64-1.79-3.16-3.16-4.52l-80.45-79.93zM69.03 332.8l105.03 103.23 215.22-215.22-104.09-104.17L69.03 332.8zm86.27 113.97-96.28-94.62-27.86 99.15c-4.45 15.91-7.46 28.06-9.05 36.44 19.79-5.98 40.2-11.61 59.73-18.29 10.75-3.39 21.78-6.87 39.25-12.28l24.1-7.34 10.11-3.06zM402.45 2.91c4.5 1.89 8.61 4.69 12.3 8.37l80.45 79.93c3.35 3.33 5.9 7.12 7.68 11.27l.43.96c1.81 4.57 2.69 9.48 2.69 14.56 0 4.87-.8 9.56-2.45 13.97l-.23.63c-1.79 4.53-4.47 8.67-8.08 12.28l-44.64 44.6c-4.07 4.05-10.66 4.03-14.71-.04L317.04 70.11c-4.07-4.07-4.07-10.68 0-14.76l44.08-44.07c3.65-3.66 7.72-6.45 12.23-8.36C377.92.98 382.77 0 387.91 0c5.1 0 9.94.97 14.54 2.91zM174.77 462.66l-23.54 7.07-24.03 7.32c-30.42 9.57-60.67 18.96-91.16 28.28-10.56 3.19-17.58 5.27-20.89 6.17-1.41.4-2.83.54-4.3.39-6.12-.62-9.68-4.3-10.63-11.06-.33-2.28-.28-5.21.13-8.77 1.03-9 4.62-24.47 10.75-46.39l32.27-114.82c.5-1.78 1.43-3.33 2.66-4.55L277.79 94.52c4.07-4.07 10.68-4.07 14.76 0l118.84 118.97c4.05 4.07 4.03 10.65-.02 14.7l-231.66 231.7a10.373 10.373 0 0 1-4.94 2.77z"/></svg>
    </button> { showEditMenu ? <EditMenu /> : null } */}
{/* <FloatingActionButtonZoom/> */}
<div>
      <Dialog
        fullScreen={fullScreen}
        open={dialogopen}
        onClose={handleDialogClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Move Corner Record to the new location marked by X?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Do you wish to move the chosen corner record to the new location? By clicking OK you confirm the location update.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleDialogClose}>
            Cancel
          </Button>
          <Button onClick={handleDialogOK} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={dialogopenReplaceCR}
        onClose={handleDialogClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Replace Corner Record geometry?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
           By clicking OK you confirm selected corner record geometry to be replaced by {searchCr} geometry.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleDialogClose}>
            Cancel
          </Button>
          <Button onClick={handleDialogOKCrReplace} autoFocus>
            Replace
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={dialogopenAddXY}
        onClose={handleDialogClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Add Corner Record to the location marked by X?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
           By clicking OK you confirm corner record point creation.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleDialogClose}>
            Cancel
          </Button>
          <Button onClick={handleDialogOKAddXY} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={dialogDeleteCropen}
        onClose={handleDialogClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Delete the selected Corner Record?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
          {toolSelectedfor} by clicking OK you confirm the deletion.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleDialogClose}>
            Cancel
          </Button>
          <Button onClick={handleDialogDeleteOK} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={dialogNotDeleteOpen}
        onClose={handleDialogClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Sorry cannot be deleted"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
             You can move the point but cannot delete the only point. 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleDialogClose}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={dialogopenAddFB}
        onClose={handleDialogClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Add Corner Records to the selected Fabric Points?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            By clicking OK you confirm the creation of new corner record points.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleDialogClose}>
            Cancel
          </Button>
          <Button onClick={handleDialogAddFBOK} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={dialogopenUpdateAttributes}
        onClose={handleDialogClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Update Attributes?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Click Update to update attributes {showEditBatchForm == true?<>{fromCRLabel} {toCRLabel}</>:""}.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleDialogClose}>
            Cancel
          </Button>
          
          {showEditBatchForm == true?<><Button onClick={handleDialogUpdateBatchAttributes} autoFocus>
            Update Batch
          </Button></>:<Button onClick={handleDialogUpdateAttributes} autoFocus>
            Update
          </Button>}
        </DialogActions>
      </Dialog>
    </div>
  
    {showEditAttributesForm == true?<>

    {showEditBatchForm == true?<><Typography p={2} variant="h5">Batch Edit</Typography></>:<Typography p={2} variant="h5">Edit Attributes</Typography>}
    <Box
      component="form"
      sx={{
        '& > :not(style)': { m: 1, width: 19/20 },
      }}
      noValidate
      autoComplete="off"
    >
      {showEditBatchForm == true?<>
        <TextField
        id="outlined-controlled"
        label="Year"
        InputProps={{ inputProps: { min: 1900} }}
        value={year}
        type="number" 
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setYear(Number(event.target.value));
        }}
      />
          <TextField
        id="outlined-controlled"
        label= {fromCRLabel}
        value={fromCR}
        type="number" 
        InputProps={{ inputProps: { min: 0} }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setFromCR(Number(event.target.value));
        }}
      />
      <TextField
        id="outlined-controlled"
        label={toCRLabel}
        value={toCR}
        type="number" 
        InputProps={{ inputProps: { min: 0} }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setToCR(Number(event.target.value));
        }}
      />
      </>:""}
      <TextField
        id="outlined-controlled"
        label="City"
        value={city}
        InputProps={{
          endAdornment: (
            <InputAdornment className = "cr_edit_icons" position="end" onClick={getCityName}  style={curPointer} >
              <AddLocationIcon/>
            </InputAdornment>
          ),
        }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setCity(event.target.value);
        }}
      />
        {/* <TextField
        id="outlined-controlled"
        label="Corner Record No."
        value={crnum}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setCrnum(event.target.value);
        }}
      /> */}
      <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Status</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={status}
        label="Status"
        onChange={handleChangeCrStatus}
      >
        <MenuItem value={'Initiated'}>Initiated</MenuItem>
        <MenuItem value={'In Progress'}>In Progress</MenuItem>
        <MenuItem value={'Filed'}>Filed</MenuItem>
      </Select>
     </FormControl>   
        <TextField
        id="outlined-controlled"
        label="Eng. Co"
        value={engco}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setEngco(event.target.value);
        }}
      />

        <TextField
        id="outlined-controlled"
        label="Eng/Svy Name"
        value={engsvyname}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setEngsvyname(event.target.value);
        }}
      />
        <TextField
        id="outlined-controlled"
        label="Eng/Svy No."
        value={engsvynum}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setEngsvynum(event.target.value);
        }}
      />
        <TextField
        id="outlined-controlled"
        label="Filed Date"
        type="date"
        value={fileddate}
        // InputProps={{
        //   startAdornment: (
        //     <InputAdornment class = "cr_edit_icons" position="start">
        //       <TodayIcon />
        //     </InputAdornment>
        //   ),
        // }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setFiledDate(event.target.value);
        }}
      />
{/* 
        <TextField
        id="outlined-controlled"
        label="mslink"
        value={mslink}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setMslink(event.target.value);
        }}
      /> */}
      <TextField
        id="outlined-controlled"
        label="Survey Date"
        type="date"
        value={surveydate}
        // InputProps={{
        //   startAdornment: (
        //     <InputAdornment class = "cr_edit_icons" position="start">
        //       <TodayIcon/>
        //     </InputAdornment>
        //   ),
        // }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setSurveyDate(event.target.value);
        }}
      />
        {/* <TextField
        id="outlined-controlled"
        label="unincorporated"
        value={unincorporated}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setUnincorporated(event.target.value);
        }}
      />   */}
    <ButtonGroup
          disableElevation
          variant="text"
          aria-label="Disabled elevation buttons"
          size = "small"
          fullWidth={true}
        >
          <Button onClick={handleClose} endIcon={<CancelIcon />}>Cancel</Button>
          {showEditBatchForm == true?<><Button onClick={handleUpdateAttributesClicked} disabled={disableBatchEdit} endIcon={<SaveIcon />}>Update Batch</Button></>:<Button  onClick={handleUpdateAttributesClicked} endIcon={<SaveIcon />}>Update</Button>}
        </ButtonGroup>
    </Box>

    </>:""}
   
    
   </Paper> </> :""}
    {/* </ThemeProvider> */}
    </div>
  );
};

export default CornerRecordEditWidget;
